module.exports = __webpack_public_path__ + "static/hero-cans-en-GB-60dd39760f569680911abf681152ea3b.png";